import GtagService from 'modules/app/services/ga/GtagService';

class NotificationEvents {
  sendClick = (options) => {
    GtagService.sendClick({
      subcategory: 'HorizontalMenu',
      where: 'Notifications',
      ...options
    });
  };
}

export default new NotificationEvents();
